// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s-yB4","largestCol":"styles_largestCol__3JaO_","smallestCol":"styles_smallestCol__2oEQJ"};